module.exports = __webpack_public_path__ + "media/images/slide-10-ec8e32a8ebee4fdaabf436bb1f1d063f.jpg";